// /home/labdoo/zitech-nexus/frontend/src/components/Website/ServicesSection.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import ScrollReveal from '../Animation/ScrollReveal';
import StaggerReveal from '../Animation/StaggerReveal';
import './ServicesSection.css';

const ServicesSection: React.FC = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M2 12h20M12 2c2.5 2.5 4 6 4 10s-1.5 7.5-4 10M12 2c-2.5 2.5-4 6-4 10s1.5 7.5 4 10" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      title: 'Web Development',
      description: 'Custom web applications built with modern technologies, responsive design, and optimal performance.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="12" y1="18" x2="12" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Mobile App Development',
      description: 'Native and cross-platform mobile solutions for iOS and Android with seamless user experience.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 12H4M12 4v16M4 4l16 16M4 20L20 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Software Integration',
      description: 'Connect your existing systems and APIs for streamlined operations and data flow.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      ),
      title: 'IT Consultancy',
      description: 'Expert guidance on technology strategy, digital transformation, and system architecture.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 6v6l4 2M12 6c-3.5 0-6 2-6 6s2.5 6 6 6 6-2 6-6-2.5-6-6-6z" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M12 2v2M22 12h-2M4 12H2M12 22v-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Training Programs',
      description: 'Comprehensive training on modern technologies and development practices.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      title: 'Cloud Services',
      description: 'Cloud deployment, migration, and management services for scalable infrastructure.',
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6h16M4 12h16M4 18h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="1.5"/>
          <path d="M8 6v2M8 12v2M8 18v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M16 6l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      title: 'Class Marks Record',
      description: 'Efficiently manage student examination results, calculate grades, divisions, and generate comprehensive performance reports.',
    },
  ];

  const handleRequestService = (serviceTitle: string) => {
    navigate(`/request-service?service=${encodeURIComponent(serviceTitle)}`);
  };

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <ScrollReveal direction="up" duration={0.6}>
          <div className="services-header">
            <h2 className="services-title">Our Services</h2>
            <p className="services-subtitle">
              Comprehensive technology solutions tailored to your business needs
            </p>
          </div>
        </ScrollReveal>

        <StaggerReveal staggerDelay={0.1} duration={0.5}>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-item">
                {/* REMOVED the inline style that was setting different colors */}
                <div className="service-icon">
                  {service.icon}
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <span 
                  className="service-request-link"
                  onClick={() => handleRequestService(service.title)}
                >
                  Request Service →
                </span>
                <div className="service-divider"></div>
              </div>
            ))}
          </div>
        </StaggerReveal>
      </div>
    </section>
  );
};

export default ServicesSection;